var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar-row"},[_c('div',{staticClass:"back",on:{"click":_vm.goback}},[_c('img',{attrs:{"src":require("@/assets/nav-back.png"),"alt":""}})]),_c('div',{staticClass:"head-bar-name"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }